import * as React from "react";
import "./NotFound.css";

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class NotFound extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <div className="empty-icon-container">
        <h1>4&nbsp;&nbsp;&nbsp;4</h1>
        <div className="animation-container">
          <div className="bounce" />
          <div className="pebble1" />
          <div className="pebble2" />
          <div className="pebble3" />
        </div>
        <div>
          <p>Sorry! We couldn't find the requested page.</p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/NotFound/NotFound.tsx